import { Navigate } from 'react-router-dom';
import { useAuth } from '@/modules/authentication/context/AuthContext';
import { getDefaultAuthorizedRoute, hasPermission } from '@/modules/authentication/permissions';

export function PermissionRoute({
  permission,
  children,
}: {
  permission?: string | string[];
  children: React.ReactNode;
}) {
  const { user } = useAuth();

  if (!hasPermission(user, permission)) {
    return <Navigate to={getDefaultAuthorizedRoute(user)} replace />;
  }

  return <>{children}</>;
}
